<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="teams-list min-height-100"
      v-loading="loading">
      <div v-if="templates !== null" class="mb-15">
        <el-input v-model="search" :placeholder="$t('search')" class="mb-10"/>
        <el-table class="templates-table" :data="templates.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))" border>
          <el-table-column
            width="300"
            prop="name"
            :label="$t('name')">
          </el-table-column>
          <el-table-column
            prop="text"
            :label="$t('text')">
          </el-table-column>
          <el-table-column
            width="200"
            prop="flavor"
            :label="$t('flavor')">
          </el-table-column>
          <el-table-column
            width="100"
            prop="language"
            :label="$t('language')">
          </el-table-column>
          <el-table-column
            :label="$t('tools')" width="100">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('edit')"
                placement="top-start">
                <el-button
                  size="mini"
                  @click="handleTemplateEdit(scope.$index, scope.row)"
                  type="warning">
                  <i class="fas fa-pen"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        v-if="total>limit"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="limit"
        :current-page.sync="currentPage">
      </el-pagination>
      <edit
        :template="template"
        :templates="templates"
        @close-clicked="dialogVisible = false"
        @template-updated="updateRowTemplate($event)"
        :dialog-visible="dialogVisible" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Edit from '@/components/templates/Edit'

export default {
  data () {
    return {
      addTemplateDialogVisible: false,
      dialogVisible: false,
      currentPage: 1,
      loading: false,
      currentRow: 0,
      query: {},
      limit: 20,
      template: {},
      templates: null,
      search: '',
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ]),
    offset () {
      return (this.currentPage - 1) * this.limit
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    updateRowTemplate (template) {
      this.dialogVisible = false
      this.getData()
    },
    handleTemplateEdit (currentRow, template) {
      this.template = template
      this.dialogVisible = true
      this.currentRow = currentRow
    },
    handleGetDataSuccess (res) {
      const { list } = res
      this.templates = list
      this.total = res.total
    },
    async getData () {
      const { limit, offset, query } = this
      const { domainsPath } = this
      this.toggleLoading()
      this.handleRequest({
        name: `${domainsPath}/templates`,
        action: 'getAll',
        data: {
          query: {
            limit,
            offset,
            ...query
          }
        }
      }).then(this.handleGetDataSuccess)
        .finally(this.toggleLoading)
    }
  },
  watch: {
    currentPage () {
      this.getData()
    }
  },
  created () {
    this.getData()
  },
  components: {
    Edit
  }
}
</script>
